import { createStore, combineReducers, applyMiddleware } from 'redux';
import { persistStore, autoRehydrate } from 'redux-persist';
import { asyncSessionStorage } from 'redux-persist/storages';
import thunkMiddleware from 'redux-thunk';
import { routerReducer, routerMiddleware, syncHistoryWithStore } from 'react-router-redux';
import { composeWithDevTools } from 'redux-devtools-extension';

import appHistory from './appHistory';
import { USER_LOGOUT } from './data/login/actionTypes';
import login from './data/login/reducer';
import home from './data/home/reducer';
import bidSession from './data/bidSession/reducer';
import linearCalendar from './data/linearCalendar/reducer';
import bidPreferenceClasses from './data/bidClasses/reducer';
import calendarActivities from './data/calendarActivities/reducer';
import openTimeSearch from './data/openTimeSearch/reducer';
import reports from './data/reports/reducer';
import settings from './data/settings/reducer';
import impersonate from './data/impersonate/reducer';

const appReducer = combineReducers({
  login,
  home,
  bidSession,
  linearCalendar,
  bidPreferenceClasses,
  calendarActivities,
  openTimeSearch,
  reports,
  settings,
  impersonate,
  routing: routerReducer,
});

/* Clean Redux Store at its root level */
const rootReducer = (state, action) => {
  if (action.type === USER_LOGOUT) {
    const { routing } = state;
    state = { routing };
  }
  return appReducer(state, action);
};

const routeMiddleware = routerMiddleware(appHistory);
const middleware = applyMiddleware(thunkMiddleware, routeMiddleware);

const store = createStore(
  rootReducer,
  undefined,
  composeWithDevTools(middleware, autoRehydrate())
);

/* Persist login store in session storage */
const persistStoreConfig = {
  storage: asyncSessionStorage,
  whitelist: ['login', 'openTimeSearch'],
  debounce: 0,
};

persistStore(store, persistStoreConfig);

syncHistoryWithStore(appHistory, store);
export default store;
